import { fg } from '@atlaskit/platform-feature-flags/fg';
import type { SearchUseCaseId } from '@atlassian/search-common/search-use-case-id';

/**
 * Temporary rollout gate retained under its existing operational name. It controls wire emission
 * for the typed AFM Search GraphQL paths and should be removed after rollout is complete.
 */
export const SEARCH_USE_CASE_ID_PROPAGATION_GATE = 'search_interactive_propagate_use_case_id';

/**
 * Applies rollout control only when a resolved, typed identity is serialized onto the wire.
 * Migrated business and request-building code must provide the identity before this boundary.
 */
export const getSearchUseCaseIdForRequest = (
	useCaseId?: SearchUseCaseId,
): SearchUseCaseId | undefined =>
	useCaseId !== undefined && fg(SEARCH_USE_CASE_ID_PROPAGATION_GATE) ? useCaseId : undefined;

export type SearchUseCaseIdWireVariables = {
	useCaseId?: SearchUseCaseId;
};

export const toSearchUseCaseIdWireVariables = <TVariables extends object>(
	variables: TVariables & { useCaseId?: SearchUseCaseId },
): Omit<TVariables, 'useCaseId'> & SearchUseCaseIdWireVariables => {
	const { useCaseId, ...rest } = variables;
	const requestUseCaseId = getSearchUseCaseIdForRequest(useCaseId);

	return requestUseCaseId === undefined ? rest : { ...rest, useCaseId: requestUseCaseId };
};
